import { z } from 'zod';

export const EditarUsuarioApiSchema = z.object({
  nombre: z.string(),
  apellido: z.string(),
  email: z.string().email().optional(),
  configuracion_json: z.record(z.any()).optional(),
  datos_externos_json: z.record(z.any()).optional()
});

export type EditarUsuarioApi = z.infer<typeof EditarUsuarioApiSchema>; 